import Translate from '../../../src/core/Translate';
import Store from '../../../src/data/Store';
import { CHART_COLOR, ROW_LAYOUT, getWidgets} from './Starter.service';
import { StarterPreset } from './StarterPreset';
import WidgetService from '../../../src/dashboard/WidgetService';

export class StarterController {
	constructor($q, $scope, $rootScope, $timeout, socket, Fullscreen, serviceAuth, USER_LEVELS, serviceSession, serviceWorkerLogdb, eventSender, $window, $element, serviceUtility) {
		this.msgbus = new Araqne.MessageBusService(null);
		this.PID = LOGPRESSO.process.getPid();
		Translate.setLocale(serviceSession.getUserLanguage());
		Araqne.UserLanguage = serviceSession.getUserLanguage();
		Araqne.UserID = serviceSession.whoAmI();
		$scope.isV4Enabled = Araqne.isV4Enabled;
		//this.client = new Araqne.QueryService(window.currentSession);

		this.$rootScope = $rootScope;
		this.$scope = $scope;
		this.$q = $q;
		this.el = $element;
		this.socket = socket;
		this.serviceUtility = serviceUtility;

		this.isCcCompliant = this.isCc();	// cc 변수가 있는지 없는지
		this.isAuthorized = serviceAuth.isAuthorized;
		this.userRoles = USER_LEVELS;

		this.tabsRawData = [];
		this.tabs = {};
		this.isLoading = false;
		this.currentTab;
		this.eventSender = eventSender;
		this.tabCount = 0;
		this.window = $window;
		if(!$scope.isV4Enabled){
			this.initEventListener();
			// widget의 service들을 초기화한다(HighchartsService, GridService 등등..)
			WidgetService.init(this.msgbus, () => {
				// get all tabs from nodes
				this.getNodeList(this.initStarterScreen);
			});
		}
	}

	initEventListener(){

		$(this.window).on(
			'resize.starter', 
			debounce(() => {
				if(!!this.currentTab){
					this.currentTab.resizeWidgets();
				}
			}
			, 200)
		);

		this.$rootScope.$on('msg:cannotRunQueryDetailViewInStarter');
		// starter events
		this.eventSender.starter.$event.on('unload', ()=>{
			if(!!this.currentTab){
				this.currentTab.suspend();
			} else {
				this.pendedSuspend = true;
			}
		});
		this.eventSender.starter.$event.on('suspend', ()=>{
			if(!!this.currentTab){
				this.currentTab.suspend();
			} else {
				this.pendedSuspend = true;
			}
		});
		this.eventSender.starter.$event.on('resume', ()=>{
			WidgetService.init(this.msgbus, () => {
				if(!!this.currentTab){
					this.currentTab.resume();
				}
			}); 
		});
	}

	isCc() {
		let ccCompliant = LOGPRESSO.organizationParameters.cc_compliant;
		if(!ccCompliant) {
			return false;
		}

		return ccCompliant === 'true' ? true : false;
	}

	initStarterScreen(){
		this.isLoading = true;
		this.initPreset();
		this.renderTab(this.currentTab);
		if(this.pendedSuspend){
			this.currentTab.suspend();
			this.pendedSuspend = false;
		}
		this.isLoading = false;
	} 

	getNodeList(deferredCallback) { // changed to callback style for the case that may to call refresh.
		let deferred = this.$q.defer();

		this.socket.send('com.logpresso.query.msgbus.FederationPlugin.getNodes', {}, this.PID)
		.success(m => {
			// console.log('get-node-list success', m);
			let nodes = m.body.nodes;
			let nodeNameMap = [];
			if(Array.isArray(nodes) && nodes.length) {
				nodeNameMap = nodes.map(node => node.name);
			}

			const localNode = [{
				name: Translate.get('$S_str_Local'),
				is_active: true,
				guid: this.serviceUtility.generateType1(),
				widgets: getWidgets(Translate.get('$S_str_Local')),
				layout: ROW_LAYOUT
			}]

			const nodeMap = nodeNameMap.sort().map(node => {
				return {
					name: node,
					is_active: false,
					guid: this.serviceUtility.generateType1(),
					widgets: getWidgets(node),
					layout: ROW_LAYOUT
				}
			});

			this.tabsRawData = localNode.concat(nodeMap);
			this.tabCount = this.tabsRawData.length;
			deferred.resolve();
		})
		.failed(msgbusFailed);

		deferred.promise.then(deferredCallback.bind(this));
	//	return deferred.promise;
	}

	resetCurrentList() {} // for the future usage.

	renderTab(tab) {
		if(tab.guid === this.currentTab.guid) {
			this.activeTab(tab);
		} else {
			console.warn('try to active wrong tab');
		}
	}

	initPreset(e, options = {}) {
		this.options = options;
		this.tabsRawData.forEach((tabRawData) => {
			this.initTab(tabRawData, options);
		});
		//this.store = new Store([], this.client);
		this.store = new Store([]);
	}

	initTab(tabRawData) {

		let newTab = undefined;
		if(!this.tabs[tabRawData.guid]) {
			newTab = this.addTab(tabRawData);
		} else {
			newTab = this.tabs[tabRawData.guid];
		}

		if(!!newTab.isActive){
			this.currentTab = newTab;
		}
		
	}

	addTab(tab) {
		let presetOptions = {
			onInfoClick: (widget) => {
				this.el.find('.propertyWidget')[0].showDialog();
				this.$scope.$broadcast('StarterWidgetPropertyController:openPropertyModal', widget, this.currentTab.guid, function(args) {
					widget.interval = args.interval;
				});
			},
			el: this.el
		};
		this.tabs[tab.guid] = new StarterPreset(tab, this.store, this.isReadOnly, presetOptions);
		return this.tabs[tab.guid];
	}

	activeTab(tab) {
		let guid = tab.guid;

		if(!!this.tabs[guid]){
			this.tabs[guid].render(this.el.find('div.dockpanel'));
			this.tabs[guid].resume();
		}
	}

	resetDataSource() {}

	changeTab(newTab) {
		if(this.currentTab.guid === newTab.guid || this.isLoading == true){
			return;
		}
		this.isLoading = true;
		this.currentTab.isActive = false;
		this.currentTab.suspend();
		this.currentTab = newTab;
		this.currentTab.isActive = true;
		this.renderTab(this.currentTab);
		this.isLoading = false;
	}
}

StarterController.$inject = ['$q', '$scope', '$rootScope', '$timeout', 'socket', 'Fullscreen', 'serviceAuth', 'USER_LEVELS', 'serviceSession', 'serviceWorkerLogdb', 'eventSender', '$window', '$element', 'serviceUtility'];


// WEBPACK FOOTER //
// ./resources/WEB-INF/package/system/starter/StarterController.js